function Contact() {
  return (
    <footer className="contact-section">
      <h2>Let&apos;s Build Something Great</h2>
      <p>
        Open to software engineering roles and collaborative product projects.
      </p>

      <div className="contact-links">
        <a href="mailto:adithnishanth@gmail.com">adithnishanth@gmail.com</a>
        <a href="https://www.linkedin.com/in/adithgunaseelan" target="_blank" rel="noreferrer">
          linkedin.com/in/adithgunaseelan
        </a>
        <a href="https://github.com/AdithNG" target="_blank" rel="noreferrer">
          github.com/AdithNG
        </a>
      </div>
    </footer>
  );
}

export default Contact;
